import React, {useRef} from 'react';
import {observer} from "mobx-react-lite";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/styles.css';
import 'react-owl-carousel2/src/owl.theme.default.css';

const GameGallery = ({images}) => {
    const sync1 = useRef(null);
    const sync2 = useRef(null);

    const item1 = {
      items: images.map(image => <div key={image.orig_image} className="item"><img src={image.orig_image} alt=""/></div>)
    };
    const item2 = {
      items: images.map(image => <div key={image.prev_image} className="item"><img src={image.prev_image} alt=""/></div>)
    };
    const sync1Options = {
        items: 1,
        nav: false,
        loop: true,
        dots: false,
        autoplay: false,
        mouseDrag: false,
        touchDrag: false,
        slideSpeed: 2000,
        autoHeight: false,
        animateOut: 'fadeOut',
        responsiveRefreshRate: 200,
        responsive: {
            0: {
                startPosition: (images.length / 2) - 1,
            },
            1280: {
                startPosition: 0,
            }
        },
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
    };

    const syncPosition = (el) => {
        // console.log(el.item);
        // const current = Math.round(el.item.index - (el.item.count / 2) - .5);
        // sync2.querySelectorAll('owl-item').classList.remove("current").eq(current).classList.add("current");
    };

    const sync1Events = {
        onChanged: syncPosition
    };

    const sync2Options = {
        items: 4,
        nav: true,
        slideBy: 1,
        navText: [''],
        loop: false,
        dots: false,
        rewind: true,
        responsiveRefreshRate: 100,
        responsive: {
            0: {
                startPosition: Math.floor((images.length / 2) - 1),
                autoWidth: true,
                nav: false,
                margin: 9,
                items: 3,
            },
            437: {
                startPosition: Math.floor((images.length / 2) - 1),
                autoWidth: true,
                nav: false,
                margin: 9,
                items: 3,
            },
            570: {
                startPosition: Math.floor((images.length / 2) - 1),
                autoWidth: false,
                nav: false,
                margin: 9,
                items: 3,
            },
            768: {
                startPosition: Math.floor((images.length / 2) - 1),
                autoWidth: false,
                nav: false,
                margin: 17,
                items: 4,
            },
            1024: {
                startPosition: Math.floor((images.length / 2) - 1),
                autoWidth: false,
                nav: false,
                margin: 27,
                items: 4,
            },
            1280: {
                startPosition: 0,
                autoWidth: false,
                nav: true,
                margin: 24.5,
                items: 4,
            }
        },
    };
    const sync2Events = {
        onInitialized: function (event) {
            if (event.target.querySelector('.current')) {
                event.target.querySelector('.current').classList.remove('current')
            }
            if (event.target.querySelector('.owl-item.active')) {
                event.target.querySelector('.owl-item.active').classList.add('current')
            }
            event.target.querySelectorAll('.owl-item').forEach((item, i) => {
                item.addEventListener('click', () => {
                    if (!item.classList.contains('current')) {
                        sync1?.current?.goTo(i);
                        if (event.target.querySelector('.current')) {
                            event.target.querySelector('.current').classList.remove('current')
                        }
                        item.classList.add('current');
                    }
                });
            });
        },
        onTranslate: function (e) {
            const stage = e.target.querySelector('.owl-stage-outer');
            if (document.body.clientWidth < 437) {
                if (e.item.count - 2 === e.item.index) {
                    stage.style.transform = 'translateX(' + (window.innerWidth - 320 + 14) + 'px)';
                } else {
                    stage.style.transform = 'translateX(0)';
                }
            } else if (document.body.clientWidth < 570) {
                if (e.item.count - 3 === e.item.index) {
                    stage.style.transform = 'translateX(' + (window.innerWidth - 437) + 'px)';
                } else {
                    stage.style.transform = 'translateX(0)';
                }
            } else if (document.body.clientWidth < 768) {
                if (e.item.count - 3 === e.item.index) {
                    stage.style.transform = 'translateX(6px)';
                } else {
                    stage.style.transform = 'translateX(-4px)';
                }
            } else if (document.body.clientWidth < 1024) {
                if (e.item.count - 4 === e.item.index) {
                    stage.style.transform = 'translateX(24px)';
                } else {
                    stage.style.transform = 'translateX(-24px)';
                }
            } else if (document.body.clientWidth <= 1280) {
                if (e.item.count - 4 === e.item.index) {
                    stage.style.transform = 'translateX(33px)';
                } else {
                    stage.style.transform = 'translateX(-29px)';
                }
            }
        }
    };

    return (
        <div className="det_left">
            <div className="det_left_img">
                <OwlCarousel id="sync1" ref={sync1} options={sync1Options} events={sync1Events} touch-action="pan-y" className="owl-carousel owl-theme" >
                    {item1.items}
                </OwlCarousel>
                <OwlCarousel id="sync2" ref={sync2} options={sync2Options} events={sync2Events} touch-action="pan-y" className="owl-carousel owl-theme" >
                    {item2.items}
                </OwlCarousel>
            </div>
        </div>
    );
};

export default observer(GameGallery);